import React, { useState, useEffect, Children } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./tabs.scss";

// use <TabPanel> inside Tabs with title props to render Tab component
const Tabs = ({ className, children, setTotalCount, renderInactivePanel }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const childrenArray = Children.toArray(children);

  const handleTabsItemChange = (index, totalCount) => {
    setSelectedIndex(index);
    setTotalCount && setTotalCount(totalCount);
  };

  const handleKeyDown = (ev, index, totalCount) => {
    // When user press Enter/Space, toggle the tooltip
    if (ev.code === "Enter" || ev.code === "Space") {
      ev.preventDefault();
      handleTabsItemChange(index, totalCount);
    }
    if (ev.code === "ArrowLeft") {
      ev.preventDefault();
      const newIndex = selectedIndex - 1;
      if (newIndex >= 0) {
        handleTabsItemChange(newIndex, totalCount);
      }
    }
    if (ev.code === "ArrowRight") {
      ev.preventDefault();
      const newIndex = selectedIndex + 1;
      if (newIndex < children.length) {
        handleTabsItemChange(newIndex, totalCount);
      }
    }
  };

  useEffect(() => {
    if (childrenArray?.length === 1) {
      setSelectedIndex(0);
    }
  }, [childrenArray]);

  return (
    <div className={classnames("tab", className)}>
      {childrenArray?.length > 0 && (
        <div role="tablist" className="tab__list">
          {childrenArray.map((panel, index) => {
            const { title, totalCount, errorCount } = panel?.props || {
              title: "",
              totalCount: 0,
              errorCount: 0,
            };
            const totalCountText = totalCount >= 0 ? ` (${totalCount})` : "";
            return (
              <button
                key={index}
                role="tab"
                type="button"
                onClick={() => handleTabsItemChange(index, totalCount)}
                onKeyDown={(ev) => handleKeyDown(ev, index, totalCount)}
              >
                <span
                  className={classnames("tab__item", {
                    "tab__item--active": selectedIndex === index,
                  })}
                >
                  {`${title}${totalCountText}`}
                  {errorCount > 0 && (
                    <span className="tab__item-error-count">
                      {errorCount <= 9 ? errorCount : "!"}
                    </span>
                  )}
                </span>
              </button>
            );
          })}
        </div>
      )}

      <div className="tab__panels">
        {renderInactivePanel
          ? childrenArray.map((c, i) => (
              <div
                key={i}
                className={classnames("tab__panel", {
                  "tab__panel--active": selectedIndex === i,
                })}
              >
                {c}
              </div>
            ))
          : childrenArray[selectedIndex]}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  setTotalCount: PropTypes.func,
  renderInactivePanel: PropTypes.bool,
};

export default Tabs;
